import { LegalPage } from '../../components/legal-page';
import { OFFER } from '../../content/legal';

/** /offer — публичная оферта / пользовательское соглашение. Public. */
export function Offer() {
  return <LegalPage doc={OFFER} canonical="/offer" />;
}
